import {get, post} from '../../utils/httpUtils';

export default {
    getCredentials: () => get('providers/me/api-credentials'),
    regenerateCredentials: () => post('providers/me/api-credentials'),
};
